import { render, staticRenderFns } from "./Oracle.vue?vue&type=template&id=3acf623c"
import script from "./Oracle.vue?vue&type=script&lang=js"
export * from "./Oracle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports